import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import MemberLoginLogTable from '../MemberLoginLogTable'
import { GetMemberLoginHistoryTableData } from '@/modules/manage-member/type'

interface MemberLoginLogListingProps {
	data: GetMemberLoginHistoryTableData[]
	total: number
	isLoading?: boolean
}

export default function MemberLoginLogListing({
	data,
	total,
	isLoading,
}: MemberLoginLogListingProps) {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title={`ประวัติการเข้าสู่ระบบ`}
					description="ประวัติการเข้าสู่ระบบ"
				/>
			</div>
			<Separator />
			<MemberLoginLogTable data={data} total={total} isLoading={isLoading} />
		</div>
	)
}
